import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';
import type { TemplateAssignmentEntryPayload } from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentsFetched';

// Same shape as one entry of the `GET` response, for this single document type.
export type TemplateAssignmentSavedPayload = TemplateAssignmentEntryPayload;

export type TemplateAssignmentSavedAction = {
	type: 'TEMPLATE_ASSIGNMENT_SAVED';
	payload: TemplateAssignmentSavedPayload;
	scope: TemplateAssignmentScope;
};

export default (
	payload: TemplateAssignmentSavedPayload,
	scope: TemplateAssignmentScope,
): TemplateAssignmentSavedAction => ({
	type: 'TEMPLATE_ASSIGNMENT_SAVED',
	payload,
	scope,
});
